export default function Advertisement() {
    return (
        <div>

        </div>
    );
}